import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventsApi } from '../../api';
import HrnbLoader from '../controls/HrnbLoader';
import HrnbButton from '../controls/HrnbButton';

export default function UpcomingEventsWidget() {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const fetch = async () => {
            try {
                const data = await eventsApi.getUpcoming();
                const list = Array.isArray(data) ? data : (data?.content || []);
                if (mounted) setEvents(list.slice(0, 5));
            } catch (err) {
                console.error('[UpcomingEventsWidget]', err.message);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetch();
        return () => { mounted = false; };
    }, []);

    const handleNavigate = () => navigate('/events');

    if (loading) {
        return (
            <div className="main-widget">
                <h3 className="main-widget__title">📅 Ближайшие события</h3>
                <div className="main-widget__loading">
                    <HrnbLoader size={32} text="Загрузка..." />
                </div>
            </div>
        );
    }

    if (events.length === 0) {
        return (
            <div className="main-widget">
                <h3 className="main-widget__title">📅 Ближайшие события</h3>
                <p className="main-widget__empty">Пока нет запланированных событий</p>
                <HrnbButton variant="outline" size="sm" onClick={handleNavigate}>
                    📅 В календарь
                </HrnbButton>
            </div>
        );
    }

    return (
        <div className="main-widget">
            <h3 className="main-widget__title">📅 Ближайшие события</h3>
            <div className="main-widget__list">
                {events.map((evt) => (
                    <EventItem key={evt.id} event={evt} onClick={() => navigate(`/events`)} />
                ))}
            </div>
            <HrnbButton variant="outline" size="sm" onClick={handleNavigate}>
                📅 Все события
            </HrnbButton>
        </div>
    );
}

function EventItem({ event, onClick }) {
    const start = parseDate(event.startTime);
    return (
        <button className="main-widget__item main-widget__item--event" onClick={onClick} type="button">
            <div className="main-widget__item-date">
                <span className="main-widget__item-day">{start ? start.getDate() : '?'}</span>
                <span className="main-widget__item-month">{start ? MONTH_SHORT[start.getMonth()] : ''}</span>
            </div>
            <div className="main-widget__item-body">
                <span className={`main-widget__item-badge main-widget__item-badge--${(event.eventType || 'CUSTOM').toLowerCase()}`}>
                    {getEventTypeLabel(event.eventType)}
                </span>
                <span className="main-widget__item-text">{event.title}</span>
                <span className="main-widget__item-time">
                    {start ? start.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : ''}
                </span>
            </div>
        </button>
    );
}

function parseDate(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
}

const MONTH_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

function getEventTypeLabel(type) {
    const labels = {
        BATTLE_START: 'Баттл',
        ROUND_START: 'Раунд',
        VOTING_START: 'Голосование',
        REGISTRATION_DEADLINE: 'Регистрация',
        TRACK_UPLOAD_DEADLINE: 'Загрузка',
        LIVE_STREAM: 'Стрим',
        MEETING: 'Встреча',
        CUSTOM: 'Другое',
    };
    return labels[type] || type || 'Другое';
}
